import { Injectable } from '@angular/core';
import { TelemetryContextService } from '@rccl/telemetry-angular';
import { User } from '~app/shared/models/user.model';
import { environment } from '~env';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class Auth2Service {
  public authToken: string;

  constructor(private readonly auth: AuthService, private readonly telemetryContextService: TelemetryContextService) {}

  public authenticate(token: string): User {
    this.auth.authenticate(token); // Fallback for old services. Remove after migration
    const user = new User(token);
    this.telemetryContextService.updateUserId(user.id);
    return user;
  }

  public redirectToLogin(): void {
    window.location.replace(environment.auth.authPage);
  }

  public getTokenFromLocalStorage(): string {
    return window.localStorage.getItem('authToken');
  }
}
